<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-card>
                <v-card-title>Kanal zuweisen</v-card-title>
                <v-tabs
                        v-model="tab"
                        background-color="#EEEEEE"
                        color="black"
                        grow
                >
                  <v-tab>Kanäle</v-tab>
                  <v-tab>Standorte</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <TablePlayList ref="tableChannels" :removeVeranstalter="removeVeranstalter" :showTitle="false" :companyId="companyId" :isCompanyView="true"/>
                  </v-tab-item>
                  <v-tab-item>
                    <TableStandorte ref="tableStandorte" :showTitle="false" :companyId="companyId" :isCompanyView="true"/>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doRemove()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Entfernen
        </v-btn>
        <v-btn @click="doSave()" color="green darken-4" small dark outlined
               class="radiusBtn text-none">Verteilen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import Vue from 'vue'
import TablePlayList from './../../tables/TableChannels'
import TableStandorte from './../../tables/TableStandorte'

export default {
  name: 'DialogLinkChannels',
  components: {TablePlayList, TableStandorte},
  props: ['removeVeranstalter'],
  methods: {
    /**
     * newName, title, type
     * @param cardConfig
     */
    doCancel: function () {
      this.dialog = false
      this.$emit('cancel', null)
    },
    doSave: function () {
      this.dialog = false
      var playlists = this.$refs.tableChannels.getSelected()
      var locations = this.$refs.tableStandorte.getSelected()
      this.$emit('save', {
        playlists: playlists,
        locations: locations
      })
    },
    doRemove: function () {
      this.dialog = false
      var playlists = this.$refs.tableChannels.getSelected()
      var locations = this.$refs.tableStandorte.getSelected()
      this.$emit('remove', {
        playlists: playlists,
        locations: locations
      })
    },
    select: function (item) {
      console.log('onSelect', item)
      this.dialog = false
      this.$emit('save', item)
    },
    open: function (cardConfig, companyId) {
      this.companyId = companyId
      if ((cardConfig != null) && (cardConfig)) {
        this.title = cardConfig.title
        this.description = cardConfig.description
      }
      this.dialog = true
      this.reload()
    },
    reload: function () {
      console.log('this.$refs', this.$refs)
      // this.$refs.tableChannels.reload()
    }
  },
  data () {
    return {
      headers: [
        {text: 'Name', align: 'left', value: 'name'}
      ],
      tab: 0,
      search: '',
      companyId: '',
      deviceList: [],
      title: 'Login nicht erfolgreich',
      description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
      dialog: false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
